import { cn } from '@/lib/utils';
import { Missing } from '../utils/validation';

/** For a control that already draws its own box — an Input, a Textarea, a
 * SearchSelect. Swaps the border, so the red sits on the control itself. */
export const redlineControl = (bad: boolean): string | undefined =>
  bad ? 'border-destructive focus-visible:ring-destructive' : undefined;

/** For a set of controls with no single box of their own — the radio grids, the
 * software chips, the XY board. Goes on the element wrapping only the controls,
 * never one that also holds the label or the message.
 *
 * A ring, matching every other highlight in the wizard. `ring-offset-background`
 * is not optional: the offset defaults to white and would halo on the step's
 * own background. */
export const redlineGroup = (bad: boolean): string | undefined =>
  bad
    ? 'rounded-xl ring-2 ring-destructive ring-offset-2 ring-offset-background'
    : undefined;

/** What the field still needs, under the field itself. */
export default function FieldError({
  missing,
  field,
  show,
  className,
}: {
  missing: Missing[];
  field: string;
  show: boolean;
  className?: string;
}) {
  const hit = missing.find((m) => m.field === field);
  if (!hit || !show) return null;
  return (
    <p
      className={cn(
        'mt-2 text-xs font-medium text-destructive',
        'animate-in fade-in duration-fast fill-mode-both motion-reduce:animate-none',
        className
      )}
    >
      Add {hit.label}
    </p>
  );
}
